import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router';

const LoyaltyHome = (props) => {
    const loyaltyPrograms = useSelector(state => state.loyaltyApp.loyaltyPrograms);

    if (!loyaltyPrograms.length) return null;

    return <Redirect to={{ pathname: `/loyaltyProgram/${loyaltyPrograms[0].id}` }} />;
};

LoyaltyHome.propTypes = {
    
};

export default LoyaltyHome;